import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function AlertDialog(props) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const { isOpen, setIsOpen } = props;

    const onCloseDialog = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsOpen(false);
    };

    const onClickBtnConfirm = () => {
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseDialog(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {/* Message Confirm */}
                    {trI18n('COMMSG058')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onClickBtnConfirm}
                >
                    {/* OK */}
                    {trI18n('COMBTN006')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
